module.exports = __webpack_public_path__ + "img/huggy-icon.5e371b13.svg";